import React, { Component,useState,useEffect } from 'react';
import CountUp from 'react-countup';
import Datepicker from '../../common/datepicker';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect } from 'react-redux';
import { useHistory } from "react-router-dom";
import { API_BASE_URL } from '../../../config.js'
import DynamicTable from '../../DynamicTable.js';
import DataTable from 'react-data-table-component';

import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



const Leave = (props) => {
const sparkline1 = React.createRef();
const sparkline2 = React.createRef();
const sparkline3 = React.createRef();
const sparkline4 = React.createRef();

const [formData, setFormData] = useState({
from_date: '',
to_date: '',
user_id:'5',
});
const [options, setData] = useState([]); 
const [table, setTable] = useState([]); 
const [settype, setType] = useState([]);
const [setcount, setCount] = useState([]);
const [setcompoff, setComp] = useState([]);
const [setcompcount, setCompCount] = useState([]);

const [sample, setlist] = useState([]); 

const [loading, setLoading] = useState(false);
const [error, setError] = useState(null);

const [user_info, setinfo] = useState([]);





const handleChange = (e) => {
  
const { name, value } = e.target;
setFormData({
...formData,
[name]: value,
});
};
const imageStyle = {
  width: '300px',
  height: 'auto',
  borderRadius: '10px',
}








// useEffect(async() => {
//   setLoading(true);
//   setError(null); // Clear any previous errors
//   try {
//     const response = await fetch('http://127.0.0.1:8000/api/user_info');
//     if (!response.ok) {
//       throw new Error('Network response was not ok');
//     }
//     const result = await response.json();
//     console.log("haiiiiii")
//     console.log(result.data);
//       setinfo(result.data[0]);
//   } catch (err) {
//     setError(err.message);
//   } finally {
//     setLoading(false);
//   }
// },[]);

useEffect(() => {
  axios.get(API_BASE_URL + '/user_info', {
    headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
  })

    // .then(res =>console.log(res.data))
    .then(res => setinfo(res.data))
    .catch(err => console.log(err));
}, [])

useEffect(() => {
  const token = '302|whIIai9tSr5YxTndtqSzWUcplm0aDnIfYuWeFZyra9ac3284'; 
  
  axios
    .get(API_BASE_URL+'/leave_type', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setTable(response.data.data.table);
      setCount(response.data.data);

     console.log(response.data.data.sl);
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);



useEffect(() => {
  
  axios
    .get(API_BASE_URL+'/leavetypelist', {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,
    }
    })
    .then((response) => {
      setType(response.data.data.leave_type);
     
    
      setLoading(false);
    })
    .catch((error) => {
    setError(error.message);
    setLoading(false);
    });
}, []);






const compoffchangeoption= async(dateval) => {
  setLoading(true);
  setError(null); // Clear any previous errors
  try {
  
    const response = await axios.post(API_BASE_URL +'/comp_off', {'from_date':dateval}, {
     
        headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

        'Content-Type': 'application/json', // Ensure JSON data is sent
      },
    });
  
    // console.log("Response received:");
    console.log(response.data.data.count);
  
    setComp(response.data.data.comp_table);
    setCompCount(response.data.data.count);

  } catch (err) {
    // Handle errors (both network and server)
    setError(err.response ? err.response.data.message : err.message);
  } finally {
    setLoading(false); // Stop loading spinner or indicator
  }
  
};


const handleSubmit =  async (e) => {

e.preventDefault(); // Prevent the default form submission

console.log('Form submitted:', formData);



axios.post(API_BASE_URL+'/add_leave' ,formData, {
  headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` ,

  'Content-Type': 'application/json', // Ensure JSON data is sent
},
}).then(response => {
   //  console.log(response.data);
        //  console.log(response.data.message);
        // })
        var status =response.data.status;
            if (status=='success')
            {
                toast.success(response.data.message, {
                    position: "bottom-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    });
                    setTimeout(() => {
                      window.location.reload(); // Reload the page after delay
                    }, 3000);
                   
            }
           else if (status=='error')
              {
                  toast.error(response.data.message, {
                      position: "bottom-right",
                      autoClose: 5000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "colored",
                      });
                      // setTimeout(() => {
                      //   window.location.reload(); // Reload the page after delay
                      // }, 3000);
                     
              }
           
        }).catch(error => {
        
            // console.log(error);
            // console.log(error.response.data.message);
            toast.error(error.response.data.message, {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                });
         });




};



const call=async(event) => { 
  const value= event.target.value;

  compoffchangeoption(value);
}







const { fixNavbar, statisticsOpen, statisticsClose } = props;
const columns = [
  {
    name: 'Name',
    selector: row => row['Name'],
    sortable: true,
  },
  {
    name: 'Leave Type',
    selector: row => row['Leave Type'],
    sortable: true,
  },
  {
    name: 'Duration',
    selector: row => row['Duration'],
     sortable: true,
  },
  {
    name: 'Applied On',
    selector: row => row['Applied On'],
    sortable: true,
  },
  {
    name: 'Reason',
    selector: row => row['Reason'],
    wrap: true,
  },
  {
    name: 'Status',
    selector: row => row['Status'],
    cell: row => (
      <span
        className={`badge ${
          row['Status'] === 'Approved'
            ? 'badge-success'
            : row['Status'] === 'Rejected'
            ? 'badge-danger'
            : 'badge-warning'
        }`}
      >
        {row['Status']}
      </span>
    ),
  },
];


return (
<>
<div>
<div>
<div className={`section-body ${fixNavbar ? "marginTop" : ""} `}>
<ToastContainer/>
<div className="container-fluid">



<div className="row">
<div className="col-lg-3 col-md-4">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available SL</span>
<h3 className="mb-0">

<span className="counter">	<CountUp  /> {setcount.sl}</span>
</h3>
</div>
<div className="w_chart">
<div id="mini-bar-chart1" className="mini-bar-chart" />
</div>
</div>
</div>
{/* 
<div className="w_chart">
<span
ref={sparkline1}
id="mini-bar-chart1"
className="mini-bar-chart"
></span>
</div>
*/}
</div>
<div className="col-lg-3 col-md-6">
<div className="card">
<div className="card-body w_sparkline">
<div className="details">
<span>Available CL</span>
<h3 className="mb-0">
{/* /<CountUp end={user_info.leave_available} /> */}
<span >{setcount.cl}</span>
</h3>
</div>
<div className="w_chart">
<span
ref={sparkline2}
id="mini-bar-chart2"
className="mini-bar-chart"
/>
</div>
</div>
</div>
</div>
{/* Gender Based Leave Card */}
{setcount.gender === "male" ? (
  // 🧑 Male → Show Paternity Leave
  <div className="col-lg-3 col-md-6">
    <div className="card">
      <div className="card-body w_sparkline">
        <div className="details">
          <span>Available Paternity</span>
          <h3 className="mb-0 counter">
            <CountUp end={setcount.pl} /> {setcount.pl}
          </h3>
        </div>
        <div className="w_chart">
          <span ref={sparkline3} id="mini-bar-chart3" className="mini-bar-chart" />
        </div>
      </div>
    </div>
  </div>
) : (
  // 👩 Female → Show Maternity Leave
  <div className="col-lg-3 col-md-6">
    <div className="card">
      <div className="card-body w_sparkline">
        <div className="details">
          <span>Available Maternity</span>
          <h3 className="mb-0 counter">
            <CountUp end={setcount.ml} /> {setcount.ml}
          </h3>
        </div>
        <div className="w_chart">
          <span ref={sparkline3} id="mini-bar-chart3" className="mini-bar-chart" />
        </div>
      </div>
    </div>
  </div>
)}

</div>

<form onSubmit={handleSubmit}>
  <div className="col-12">
    <div className="card">
      <div className="card-body">

        <div className="row">

          {/* LEAVE TYPE */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="form-group">
              <label>
                Leave Type 
              </label>

              <Select
                classNames={{
                  control: () => "required-select required-tooltip"
                }}
                options={settype.map(l => ({
                  value: l.value,
                  label: l.label
                }))}
                value={
                  settype
                    .map(l => ({
                      value: l.value,
                      label: l.label
                    }))
                    .find(opt => opt.value === formData.leave_type) || null
                }
                onChange={(selected) => {
                  setFormData(prev => ({
                    ...prev,
                    leave_type: selected ? selected.value : ""
                  }));
                }}
                placeholder="Search Leave Type..."
                className="form-control p-0"
              />
            </div>
          </div>

          {/* FROM DATE */}
          <div className="col-lg-4 col-md-6 col-12">
            <div className="form-group required-tooltip">
              <label>
                From Date
              </label>

              <input type="hidden" name="user_id" value={formData.user_id} />

             <DatePicker
  selected={formData.from_date ? new Date(formData.from_date) : null}
  onChange={(date) => {
    const value = date
      ? date.toLocaleDateString('en-CA')
      : "";

    setFormData(prev => ({ ...prev, from_date: value }));
    compoffchangeoption(value);
  }}
  dateFormat="yyyy-MM-dd"
  placeholderText="Select From Date"
  className="form-control required-input"
/>

            </div>
          </div>

          {/* TO DATE */}
          <div className="col-lg-4 col-md-6 col-12">
          <div className="form-group required-tooltip">
  <label>To Date</label>

  <DatePicker
    selected={formData.to_date ? new Date(formData.to_date) : null}
    onChange={(date) => {
      const value = date
        ? date.toLocaleDateString('en-CA')
        : "";

      setFormData(prev => ({ ...prev, to_date: value }));
    }}
    dateFormat="yyyy-MM-dd"
    placeholderText="Select To Date"
    className="form-control required-input"
    minDate={formData.from_date ? new Date(formData.from_date) : null}
  />
</div>

          </div>

          {/* COMP OFF */}
          {formData.leave_type == 5 && (
            <div className="col-lg-4 col-md-6 col-12">
              <div className="form-group">
                <label>
                  Select Compensatory Off ({setcompcount}){" "}
                  <span className="form-required">*</span>
                </label>

                <select
                  className="form-control custom-select"
                  name="combooff_days"
                  value={formData.combooff_days}
                  onChange={handleChange}
                >
                  <option value="">Select Comp Off</option>
                  {setcompoff.map(option => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          {/* REASON */}
          <div className="col-12">
            <div className="form-group required-tooltip">
              <label>
                Reason 
              </label>

              <textarea
                rows={4}
                className="form-control required-input"
                placeholder="Reason"
                name="reason"
                value={formData.reason}
                onChange={handleChange}
              />
            </div>
          </div>

          {/* BUTTON */}
          <div className="col-12 text-right">
            <button type="submit" className="btn btn-round btn-primary">
              Save
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</form>


</div>
</div>
<div className="section-body">
<div className="container-fluid">
<div className="tab-content">
<div className="tab-pane fade show active" id="Employee-list" role="tabpanel">
<div className="card">
  <div className="card-header">
    <h3 className="card-title">Leave List</h3>
  </div>

  <div className="card-body">
    <div className="table-responsive">
      <DataTable
        columns={columns}
        data={table}
        pagination
        highlightOnHover
        striped
        responsive
      />
    </div>
  </div>
</div>

</div>

</div>
</div>
</div>

</div>
</div>

</>
);
}


export default Leave;